import { initializeForm } from "../../utils/formSubmission";

/**
 * Initializes the Pointa Marketing contact form with reCAPTCHA integration.
 * This function sets up the form when Webflow is ready, configuring it with
 * the appropriate form ID, endpoint, and reCAPTCHA site key.
 * 
 * The form initialization includes:
 * - Setting up event listeners
 * - Configuring form visibility
 * - Handling reCAPTCHA verification
 * - Managing form submission
 * 
 * @returns {void}
 */
export function initializePointamarketingContactForm(): void {
  // Initialize the form when Webflow is ready
  window.Webflow ||= [];
  window.Webflow.push(() => {
    initializeForm("contact-form", "Pointa", "6LcTWREqAAAAAEUSOaaG-gAOLxgo18VodDK95ppr");
  });
}

/**
 * Initializes the Pointa Marketing contact form with reCAPTCHA integration.
 * This function sets up the form when Webflow is ready, configuring it with
 * the appropriate form ID, endpoint, and reCAPTCHA site key.
 * 
 * The form initialization includes:
 * - Setting up event listeners
 * - Configuring form visibility
 * - Handling reCAPTCHA verification
 * - Managing form submission
 * 
 * @returns {void}
 */
export function initializePointamarketingConsultationForm(): void {
  // Initialize the form when Webflow is ready
  window.Webflow ||= [];
  window.Webflow.push(() => {
    initializeForm("consultation-form", "Pointa", "6LcTWREqAAAAAEUSOaaG-gAOLxgo18VodDK95ppr");
  });
}